/* 
▗▖  ▗▖▗▖ ▗▖▗▄▄▄▖▗▄▄▄▖▗▖  ▗▖ ▗▄▖     ▗▄▄▄▖▗▖ ▗▖▗▄▄▄▖▗▖  ▗▖▗▄▄▄▖    ▗▄▄▖ ▗▖ ▗▖▗▄▄▄▖▗▖   ▗▄▄▄ ▗▄▄▄▖▗▄▄▖ 
▐▛▚▖▐▌▐▌ ▐▌  █    █  ▐▛▚▞▜▌▐▌ ▐▌      █  ▐▌ ▐▌▐▌   ▐▛▚▞▜▌▐▌       ▐▌ ▐▌▐▌ ▐▌  █  ▐▌   ▐▌  █▐▌   ▐▌ ▐▌
▐▌ ▝▜▌▐▌ ▐▌  █    █  ▐▌  ▐▌▐▛▀▜▌      █  ▐▛▀▜▌▐▛▀▀▘▐▌  ▐▌▐▛▀▀▘    ▐▛▀▚▖▐▌ ▐▌  █  ▐▌   ▐▌  █▐▛▀▀▘▐▛▀▚▖
▐▌  ▐▌▝▚▄▞▘  █  ▗▄█▄▖▐▌  ▐▌▐▌ ▐▌      █  ▐▌ ▐▌▐▙▄▄▖▐▌  ▐▌▐▙▄▄▖    ▐▙▄▞▘▝▚▄▞▘▗▄█▄▖▐▙▄▄▖▐▙▄▄▀▐▙▄▄▖▐▌ ▐▌
  
* NUTIMA THEME BUILDER
* Shopify Theme Compiler & Generator powered by nutima
* 
* Copyright (c) 2025 nutima
* All rights reserved.
* 
* ⚠️  WARNING: This file is auto-generated by Nutima Theme Builder
* ⚠️  DO NOT EDIT this file manually - your changes will be overwritten
* ⚠️  To make changes, edit the source files and rebuild the theme
* 
* Version: 1.0.0
* Build: Production
* 
* For support: support@nutima.agency
* Website: https://nutima.agency
 */
class t{constructor(){this.customerBtn=document.querySelector(".customer-btn"),this.overlay=null,this.customerBtn&&this.init()}init(){this.customerBtn.addEventListener("mouseenter",this.showOverlay.bind(this)),this.customerBtn.addEventListener("mouseleave",this.hideOverlay.bind(this))}showOverlay(){this.overlay||this.createOverlay(),document.body.appendChild(this.overlay)}hideOverlay(){this.overlay&&this.overlay.parentNode&&this.overlay.parentNode.removeChild(this.overlay)}createOverlay(){this.overlay=document.createElement("div"),this.overlay.className="customer-overlay",this.overlay.style.cssText="\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.5);\n      z-index: 1;\n      pointer-events: none;\n    "}}document.addEventListener("DOMContentLoaded",(()=>{new t}));